import React, {useState, useEffect} from 'react';
import {Row, Col} from 'reactstrap';
import OtpVerificationComponent from './OtpVerificationComponent';
import Config from '../../../Config';
import {isMobile} from 'react-device-detect';
import {otpReportData, otpCreateReport, enumGAReport, otpCreateGAReport} from './otpReports';
import {connect} from 'react-redux';
import {setBlockSource} from './otpAuthenticationSlice';

const OtpVerificationPageWithImage = (props) => {
  useEffect(() => {
    let param1 = props.otpTitles?.blockSource;
    let reportData = otpReportData?.OTPPageDisplayed;
    props.setBlockSource(param1);

    otpCreateReport(
      reportData.Channel,
      reportData.Area,
      reportData.SubArea,
      reportData.ActionType,
      reportData.Status,
      reportData.MessageText,
      param1,
      '',
    );
  }, []);

  return (
    <div className='otp-verification_page_with_banner-main-shared'>
      {props.otpBanner && (
        <div className='justify-content-md-center otp-banner-wrapper text-center'>
          <div className='p-0 banner-content'>
            <div className='banner-container'>
              <div className='img-banner' style={{backgroundImage: `url(${Config.epiBaseUrl + props.otpBanner})`}}>
                <div className='label-container'>
                  <p className='main-banner-title-text'>{props.otpTitles?.bannerMainTitle}</p>
                  <p className='second-banner-title-text'>{props.otpTitles?.bannerSecondTitle}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <OtpVerificationComponent
        otpOrigin={props.otpOrigin}
        originProcess={props.originProcess}
        otpTitles={props.otpTitles}
        onAuthenticatedAction={props.onAuthenticatedAction}
        isInline={props.isInline}
        gaStep1Display={props.gaStep1Display}
        gaOnPhoneValidation={props.gaOnPhoneValidation}
        gaStep2Display={props.gaStep2Display}
        gaOnOtpCodeValidation={props.gaOnOtpCodeValidation}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  setBlockSource,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerificationPageWithImage);
